import axios, { AxiosRequestConfig } from 'axios';
import { stringify } from 'qs';

import BaseRequest from '@r1-frontend/do-request/core/BaseRequest';
import { IBaseRequest, TBaseUrl, TResponse } from '@r1-frontend/do-request/core/types';
import { BaseErrorBody } from '@r1-frontend/do-request/error';
import { captureQueryError } from '@r1-frontend/do-request/error/captureQueryError';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

class BaseAxiosRequest extends BaseRequest implements IBaseRequest<IRequest>  {
    constructor() {
        super();
    }

    public async doRequest<ResponseData>(
        urls: TBaseUrl,
        request: IRequest,
    ): Promise<TResponse<ResponseData, BaseErrorBody>> {
        const baseURL = this.getBaseUrl(urls);

        const axiosConfig = this.getConfig(baseURL, request);

        try {
            const response = await axios.request<ResponseData>(axiosConfig);

            return {
                isSuccess: true,
                payload: response.data,
            };
        } catch (e) {
            // TODO: Обсудить и добавить возможность пробросить кастомный обработчик ошибки
            return captureQueryError(e);
        }
    }

    private getConfig(baseURL: string, request: IRequest): AxiosRequestConfig {
        const { uri, headers, method, body, queryParams, withAuth, withProvider, signal } = request;

        const defaultHeaders = this.getDefaultHeaders(withAuth, withProvider);

        const axiosConfig: AxiosRequestConfig = {
            baseURL,
            url: uri,
            method,
            headers: {
                ...defaultHeaders,
                ...headers,
            },
            signal: signal || undefined,
        };

        // [See ‘Content-Type’ @r1-frontend/do-request/README](https://gitlab.com/r1team/d2c/frontend/b2c-domru/-/blob/master/frontend/packages/do-request)
        if (headers) {
            const headerContentType = Object.keys(headers).find(header => header.toLowerCase() === 'content-type');
            if (headerContentType && headers[headerContentType] === 'application/pdf') {
                axiosConfig.responseType = 'blob';
            }
        }

        if (queryParams) {
            axiosConfig.params = queryParams;
            axiosConfig.paramsSerializer = (param) => stringify(param);
        }

        if (['POST', 'PUT', 'PATCH'].includes(method)) {
            axiosConfig.data = body;
        }

        return axiosConfig;
    }
}

export default BaseAxiosRequest;
